// extracted by mini-css-extract-plugin
export var hasRatio = "ratio-image-module--has-ratio--ec1ff";
export var img = "ratio-image-module--img--f4b06";
export var imgBox = "ratio-image-module--img-box--aaf47";
export var ratioContainer = "ratio-image-module--ratio-container--25e57";